import usePrivateAxios from '@/common/api/usePrivateAxios';
import { useMutation } from '@tanstack/react-query';

interface useResendBillMailProps {
  id?: string;
  onSuccess?: (response: any) => void;
  onError?: (response: any) => void;
}

export const useBillingBillResendBillDocumentMail = ({ id, onSuccess, onError }: useResendBillMailProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['billingBillResendFiscalDocumentMail', id],
    mutationFn: async () => privateAxios.post(`/billing/bills/${id}/resend_mail`),
    onSuccess,
    onError,
  });
};
